import storage from 'good-storage';
import { setOut,wxLogin,ipLogin } from "@/api/login";
import store from '../store/index';
import vEmits from "@/utils/vEmits";
import router from '../router'


// function wxConfirm () {
//     let ua = window.navigator.userAgent.toLowerCase();
//     if (ua.match(/MicroMessenger/i) == 'micromessenger') {
//       return true;
//     } else {
//       return false
//     }
// }

function getUrls(name){
     var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
     var r = window.location.search.substr(1).match(reg);
     if(r != null) {
       return unescape(r[2]);
     }
     return null;
}

function logins(){

     if(getUrls('appid')){
         wxLogin({
              appid:getUrls('appid'),
              code:getUrls('code')
         }).then(res => {
              vEmits.$emit('show','登录成功');
              res.lgtype = 'wx';
              store.dispatch('user/AuserSet',res);
              router.replace('index');
         }).catch(errs => {
              router.replace('index');
              vEmits.$emit('show',errs);
              /*router.replace({
                   path:'error',
                   query:{
                       type:2
                   }
              });*/
         })
     }else{

         ipLogin({
              system:'web'
         }).then(res => {
              res.lgtype = 'ip';
              store.dispatch('user/AuserSet',res);

              //router.replace('index');
         }).catch(errs => {
             storage.set('noLogin','1')
                window.console.log(errs)
              // router.replace('index');
              /*router.replace({
                  path:'error',
                  query:{
                      type:1
                  }
              });*/
         })
     }
}

export default function(){
    if(window.screen.width < 500){
        if(storage.get("userInfo")){
            setOut().then(res => {
                window.console.log(res)
                storage.remove("userInfo");
                logins();
            }).catch(errs => {
                window.console.log(errs)
                storage.remove("userInfo");
                logins();
            })
        }else{
            logins();
        }
    }else{
        router.replace({
            path:'error',
            query:{
                type:3
            }
        });
    }

    /*if(wxConfirm()){
        storage.remove("userInfo");
        login();
        /*if(storage.get('userInfo')){
             reLogin().then(res => {
                 res.lgtype = 'token';
                 store.dispatch('user/AuserSet',res);
                 router.replace('index');
             }).catch(errs => {
                 storage.remove("userInfo");
                 login();
             })
        }else{
             login();
        }*/
    /*}else{
        router.replace({
            path:'error',
            query:{
                type:3
            }
        });
    }*/

}
